import React, { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import getObjectPropertiesPaths from '../../../../utils/getObjectPropertiesPaths/getObjectPropertiesPaths';

interface Props {
  initialData: any;
  onDirtyChange: (isDirty: boolean) => void;
  extraBlacklistedFields?: string[];
}

const CheckDirty: React.FC<Props> = ({ initialData, onDirtyChange, extraBlacklistedFields }) => {
  const { formState, getFieldState } = useFormContext();
  const [isDirty, setIsDirty] = useState<boolean>();

  let blacklistedFields = useMemo(() => {
    return ['updatedAt'];
  }, []);
  if (extraBlacklistedFields) {
    blacklistedFields = [...blacklistedFields, ...extraBlacklistedFields];
  }

  const copy = JSON.parse(JSON.stringify(initialData));

  useEffect(() => {
    const dirtyFields = getObjectPropertiesPaths(copy).map((key: any) => {
      if (blacklistedFields && blacklistedFields.includes(key)) {
        return false;
      }
      return getFieldState(key).isDirty;
    });
    const checkDirty = dirtyFields.some((val) => val);

    if (isDirty !== checkDirty) {
      setIsDirty(checkDirty);
      onDirtyChange(checkDirty);
    }
  }, [formState.dirtyFields, blacklistedFields, copy, isDirty, onDirtyChange, getFieldState]);

  return <></>;
};

export default CheckDirty;
